import { Space } from '@gr-monorepo/common/ui';
import React, { PropsWithChildren, useState } from 'react';
import { Wrap, Buttons, Close, Button, ProgressItem, Progress } from './PopupStyled';

type PopupProps = PropsWithChildren<{ style?: React.CSSProperties; close: () => void }>;
type PopupWithButtonsProps = PropsWithChildren<{
  style?: React.CSSProperties;
  stepCount: number;
  currenStepIndex: number;
  prevStep?: () => void;
  nextStep: () => void;
  close: () => void;
  buttonPrevTitle?: string;
  buttonNextTitle: string;
}>;

export const Popup = (props: PopupProps) => {
  return (
    <Wrap style={props.style} onClick={(e) => e.stopPropagation()}>
      <Close onClick={props.close} />
      {props.children}
    </Wrap>
  );
};

export const PopupWithButton = (props: PopupWithButtonsProps) => {
  return (
    <Popup close={props.close} style={props.style}>
      {props.children}
      <Buttons>
        {props.prevStep ? (
          <Button outline onClick={props.prevStep}>
            {props.buttonPrevTitle}
          </Button>
        ) : (
          <Space size={105} />
        )}
        <Space />
        <Progress>
          {new Array(props.stepCount).fill(0).map((el, i) => (
            <ProgressItem active={i === props.currenStepIndex} />
          ))}
        </Progress>
        <Space />
        <Button onClick={props.nextStep}>{props.buttonNextTitle}</Button>
      </Buttons>
    </Popup>
  );
};
